import { baseApi } from "utils/axios/baseApi";
import { APPOINTMENT_ASSIGN_CHATTER, APPOINTMENT_ASSIGN_THERAPIST, APPOINTMENT_UNASSIGN_CHATTER, CREATE_APPOINTMENT, CREATE_APPOINTMENT_INVOICE, DELETE_APPOINTMENT, GET_APPOINTMENT_ASSESSMENT_LIST, GET_APPOINTMENT_ASSIGN_CHATTER_LIST, GET_APPOINTMENT_ASSIGN_THERAPISTS_LIST, GET_APPOINTMENT_CLIENTS_LIST, GET_APPOINTMENT_CONSENT_FORMS, GET_APPOINTMENT_DETAILS, GET_APPOINTMENT_PARENTS_LIST, GET_APPOINTMENT_THERAPISTS, GET_APPOINTMENTS_LIST, GET_ASSIGNED_CONSENT_FORM, PREVIEW_CONSENT_FORM, RESEND_CONSENT_FORMS, SEND_APPOINTMENT_INVOICE, SEND_APPOINTMENT_RECIEPT, SEND_APPT_MAIL_THERAPIST, SEND_SINGLE_CONSENT_MAIL, UNASSIGN_ALL_APPOINTMENT_THERAPISTS, UNASSIGN_APPOINTMENT_THERAPIST, UPDATE_APPOINTMENT, UPDATE_APPOINTMENT_PRICE, MANAGE_APPOINTMENT_GUARDIAN_SUBMITTED_FORM_VIEW, GET_PARENT_APPOINTMENTS_LIST } from "config/apiPaths";

const appointmentManagementApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // get client appointment balance
    getAppointmentParentsList: builder.query({
      query: ({ body }) => ({
        method: "PATCH",
        url: GET_APPOINTMENT_PARENTS_LIST,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['appointmentPatientList']
    }),

    getAppointmentClientsList: builder.query({
      query: ({ body, parentId }) => {
        const config = {
          method: "PATCH",
          url: `${GET_APPOINTMENT_CLIENTS_LIST}/${parentId}`,
        };

        if (body) {
          config.data = body;
        }

        return config;
      },
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['appointmentClientList']
    }),

    getAppointmentAssessmentList: builder.query({
      query: () => ({
        method: "GET",
        url: GET_APPOINTMENT_ASSESSMENT_LIST,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['appointmentAssessmentList']
    }),

    getAppointmentConsentList: builder.query({
      query: ({ clientType }) => ({
        method: "GET",
        url: `${GET_APPOINTMENT_CONSENT_FORMS}/${clientType}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['appointmentConsentList']
    }),

    // save balance
    createAppointment: builder.mutation({
      query: ({ body }) => ({
        method: "POST",
        url: CREATE_APPOINTMENT,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['appointmentList']
    }),

    getAppointmentList: builder.query({
      query: ({ search = "", type = "", status = "", page = 1, limit = 100, payment_status }) => ({
        method: "PATCH",
        url: `${GET_APPOINTMENTS_LIST}`,
        data: {
          page,
          limit,
          search,
          // sort,
          appointment_type: type,
          status,
          payment_status
        }
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['appointmentList']
    }),

    getAppointmentDetails: builder.query({
      query: ({ id }) => ({
        method: "GET",
        url: `${GET_APPOINTMENT_DETAILS}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['appointmentDetails']
    }),

    deleteAppointment: builder.mutation({
      query: ({ id }) => ({
        method: "DELETE",
        url: `${DELETE_APPOINTMENT}/${id}`,
      }),
      invalidatesTags: ['appointmentList', "parentAppointmentList"]
    }),

    previewConsentForm: builder.query({
      query: ({ id, mode = null }) => ({
        method: "GET",
        url: `${mode === "preview" ? PREVIEW_CONSENT_FORM : GET_ASSIGNED_CONSENT_FORM}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
    }),

    updateAppointmentConsentFormStatus: builder.mutation({
      query: ({ id, status, apptId }) => ({
        method: "PUT",
        url: `appointment/updateConsentFormStatus/${id}/${status}/${apptId}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['appointmentList', 'appointmentDetails']
    }),

    updateAppointment: builder.mutation({
      query: ({ id, body }) => ({
        method: "PATCH",
        url: `${UPDATE_APPOINTMENT}/${id}`,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['appointmentList', 'appointmentDetails']
    }),

    updateAppointmentPrice: builder.mutation({
      query: ({ id, body }) => ({
        method: "PUT",
        url: `${UPDATE_APPOINTMENT_PRICE}/${id}`,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['appointmentList', 'appointmentDetails']
    }),

    getAppointmentTherapists: builder.query({
      query: ({ body }) => ({
        method: "PATCH",
        url: `${GET_APPOINTMENT_THERAPISTS}`,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
    }),

    assignAppointmentTherpaist: builder.mutation({
      query: ({ body }) => ({
        method: "POST",
        url: `${APPOINTMENT_ASSIGN_THERAPIST}`,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['assignedAppointmentTherapistsList', 'appointmentList', 'appointmentDetails']
    }),

    getAppointmentTherpaistList: builder.query({
      query: ({ id }) => ({
        method: "GET",
        url: `${GET_APPOINTMENT_ASSIGN_THERAPISTS_LIST}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['assignedAppointmentTherapistsList']
    }),

    unAssignAppointmentTherapist: builder.mutation({
      query: ({ id }) => ({
        method: "DELETE",
        url: `${UNASSIGN_APPOINTMENT_THERAPIST}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['assignedAppointmentTherapistsList']
    }),

    unAssignAllAppointmentTherapist: builder.mutation({
      query: ({ id }) => ({
        method: "DELETE",
        url: `${UNASSIGN_ALL_APPOINTMENT_THERAPISTS}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['assignedAppointmentTherapistsList']
    }),

    assignAppointmentChatter: builder.mutation({
      query: ({ body }) => ({
        method: "POST",
        url: `${APPOINTMENT_ASSIGN_CHATTER}`,
        data: body
      }),
      invalidatesTags: ['assignedAppointmentChatterList']
    }),

    unAssignAppointmentChatter: builder.mutation({
      query: ({ body }) => ({
        method: "PATCH",
        url: `${APPOINTMENT_UNASSIGN_CHATTER}`,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['assignedAppointmentChatterList']
    }),

    getAppointmentAssignedChattertList: builder.query({
      query: ({ id }) => ({
        method: "GET",
        url: `${GET_APPOINTMENT_ASSIGN_CHATTER_LIST}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['assignedAppointmentChatterList']
    }),

    createAppointmentInvoice: builder.mutation({
      query: ({ id }) => ({
        method: "PUT",
        url: `${CREATE_APPOINTMENT_INVOICE}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      // invalidatesTags: ['assignedAppointmentTherapistsList']
    }),

    sendAppointmentInvoice: builder.mutation({
      query: ({ id }) => ({
        method: "PUT",
        url: `${SEND_APPOINTMENT_INVOICE}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      // invalidatesTags: ['assignedAppointmentTherapistsList']
    }),

    sendAppointmentReciept: builder.mutation({
      query: ({ id }) => ({
        method: "PUT",
        url: `${SEND_APPOINTMENT_RECIEPT}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      // invalidatesTags: ['assignedAppointmentTherapistsList']
    }),

    resendConsentForms: builder.mutation({
      query: (id) => ({
        method: "PUT",
        url: `${RESEND_CONSENT_FORMS}/${id}`,
      }),
      invalidatesTags: ['appointmentList', 'appointmentDetails']
    }),

    sendSingleConsentForm: builder.mutation({
      query: ({ id, consentFormAssignedId }) => ({
        method: "PUT",
        url: `${SEND_SINGLE_CONSENT_MAIL}/${id}/${consentFormAssignedId}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['appointmentList', 'appointmentDetails']
    }),

    sendApptMailTherapist: builder.mutation({
      query: ({ appointmentId, therapistId }) => ({
        method: "PUT",
        url: `${SEND_APPT_MAIL_THERAPIST}/${appointmentId}/${therapistId}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
    }),

    getAppointmentGuardianSubmittedForm: builder.query({
      query: ({ id }) => ({
        method: "GET",
        url: `${MANAGE_APPOINTMENT_GUARDIAN_SUBMITTED_FORM_VIEW}/${id}`
      }),
      transformResponse: (response) => {
        return response.data;
      },
      // providesTags: ["AppointmentQuestionsList"]
    }),

    getParentAppointmentsList: builder.query({
      query: ({ page, limit, search, appointment_type, status, id }) => ({
        method: "PATCH",
        url: `${GET_PARENT_APPOINTMENTS_LIST}/${id}`,
        data: { page, limit, search, appointment_type, status }
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['parentAppointmentList']
    }),


  }),
})

export const {
  useLazyGetAppointmentParentsListQuery,
  useLazyGetAppointmentClientsListQuery,
  useGetAppointmentClientsListQuery,
  useGetAppointmentAssessmentListQuery,
  useLazyGetAppointmentConsentListQuery,
  useCreateAppointmentMutation,
  useGetAppointmentListQuery,
  useGetAppointmentDetailsQuery,
  useDeleteAppointmentMutation,
  useUpdateAppointmentConsentFormStatusMutation,
  useUpdateAppointmentMutation,
  useLazyGetAppointmentTherapistsQuery,
  useAssignAppointmentTherpaistMutation,
  useGetAppointmentTherpaistListQuery,
  useUnAssignAppointmentTherapistMutation,
  useUnAssignAllAppointmentTherapistMutation,
  useAssignAppointmentChatterMutation,
  useUnAssignAppointmentChatterMutation,
  useGetAppointmentAssignedChattertListQuery,
  useCreateAppointmentInvoiceMutation,
  useSendAppointmentInvoiceMutation,
  useSendAppointmentRecieptMutation,
  useUpdateAppointmentPriceMutation,
  useResendConsentFormsMutation,
  useSendSingleConsentFormMutation,
  usePreviewConsentFormQuery,
  useSendApptMailTherapistMutation,
  useGetAppointmentGuardianSubmittedFormQuery,
  useGetParentAppointmentsListQuery
} = appointmentManagementApi